import Image from "next/image";
import Link from "next/link";
import Copyright from "./Copyright";
import Social from "./Social";

const Footer = () => {
      return (
            <section style={{ backgroundColor: "#ffd26a", paddingBottom: 0 }}>

                  <div className="container" style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                  }}>
                        {/* Logo + Social */}
                        <div>
                              <Link className="footer-logo" href="/">
                                    <Image
                                          width={138}
                                          height={44}
                                          src="/images/olmo-default-logo.svg"
                                          alt="logo"
                                    />
                              </Link>
                              <Image
                                    width={220}
                                    height={73}
                                    src="/images/01_cloud_seal_dark.svg"
                                    alt="Secured by Axiler — protection live"
                                    style={{ display: "block", marginTop: 16 }}
                              />
                              <Social />
                        </div>      

                        {/* Two-column layout */}
                        <div className="d-flex flex-column flex-lg-row justify-content-between">
                             
                              <div className="flex-shrink-0" style={{ maxWidth: 420, width: "100%" }}>
                                    <div className="d-flex flex-column flex-md-row gap-5">
                                          <div>
                                                <p className="mb-1">Contact Us</p>
                                                <h6 className="mb-0">+880 2-9132934</h6>
                                          </div>
                                          <div>
                                                <p className="mb-1">Email</p>
                                                <strong>
                                                      <a href="#">support@olmo.homes</a>
                                                </strong>
                                          </div>
                                    </div>
                              </div>
                        </div>
                  </div>
                  <Copyright />
            </section>
      );
};

export default Footer;
